import type { Purpose } from "@/lib/mock-data";

const labels: Record<Purpose, { label: string; cls: string }> = {
  sale: { label: "For Sale", cls: "bg-sale" },
  rent: { label: "For Rent", cls: "bg-rent" },
  lease: { label: "For Lease", cls: "bg-lease" },
  parking: { label: "Parking", cls: "bg-parking" },
};

export function StatusBadge({ purpose }: { purpose: Purpose }) {
  const s = labels[purpose];
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-semibold text-white shadow-soft ${s.cls}`}
    >
      {s.label}
    </span>
  );
}

export function VerificationBadge({ status }: { status: string }) {
  const tone =
    status === "Approved"
      ? "bg-emerald-500/15 text-emerald-700 border-emerald-500/30"
      : status === "Rejected" || status === "Suspended"
        ? "bg-destructive/10 text-destructive border-destructive/30"
        : "bg-brand-soft text-brown-dark border-brand/50";
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-1 text-[11px] font-medium ${tone}`}
    >
      {status}
    </span>
  );
}
